import { camelCase } from 'lib/utils/objectSerializer';

import format from './formatter';

export const initialState = {
  branchId: undefined,
  startDate: undefined,
  endDate: undefined,
  ordersById: {},
  orders: [],

  // status of summary request
  summary: undefined,
  summaryLoading: true,
  summaryError: undefined,

  // status of summary previous request
  summaryPrevious: undefined,
  summaryPreviousLoading: true,
  summaryPreviousError: undefined,

  // status of last list request
  listLoading: false,
  listError: undefined,

  // status of last detail request
  detailLoading: false,
  detailError: undefined,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case 'LOGIN_SUCCESS': {
      return {
        ...initialState,
      };
    }

    case 'GET_MORE_RESTAURANT_ORDERS_REQUEST': {
      return {
        ...state,
        listLoading: true,
      };
    }
    case 'GET_RESTAURANT_ORDERS_REQUEST': {
      return {
        ...state,
        listLoading: true,
        listError: undefined,
      };
    }

    case 'GET_MORE_RESTAURANT_ORDERS_FAILURE':
    case 'GET_RESTAURANT_ORDERS_FAILURE': {
      return {
        ...state,
        listLoading: false,
        listError: {
          status: action.status,
          message: action.payload.error,
        },
      };
    }

    case 'GET_RESTAURANT_ORDERS_SUCCESS':
    case 'GET_MORE_RESTAURANT_ORDERS_SUCCESS': {
      const { orders, ordersById } = format.orders(action.payload);
      const { branchId, startDate, endDate } = action.extra;
      const shouldReplace =
        branchId !== state.branchId ||
        startDate !== state.startDate ||
        endDate !== state.endDate ||
        action.type === 'GET_RESTAURANT_ORDERS_SUCCESS';

      return {
        ...state,
        branchId,
        startDate,
        endDate,
        orders: shouldReplace ? orders : state.orders.concat(orders),
        ordersById,
        listLoading: false,
        listError: undefined,
      };
    }

    case 'GET_RESTAURANT_ORDER_SUMMARY': {
      return {
        ...state,
        summaryLoading: true,
        summaryError: undefined,
      };
    }

    case 'GET_RESTAURANT_ORDER_SUMMARY_FAILURE': {
      return {
        ...state,
        summaryLoading: false,
        summaryError: camelCase(action.payload),
      };
    }

    case 'GET_RESTAURANT_ORDER_SUMMARY_SUCCESS': {
      return {
        ...state,
        summaryLoading: false,
        summary: format.summary(action.payload),
      };
    }

    case 'GET_RESTAURANT_ORDER_SUMMARY_PREVIOUS_REQUEST': {
      return {
        ...state,
        summaryPreviousLoading: true,
        summaryPreviousError: undefined,
      };
    }

    case 'GET_RESTAURANT_ORDER_SUMMARY_PREVIOUS_FAILURE': {
      return {
        ...state,
        summaryPreviousLoading: false,
        summaryPreviousError: camelCase,
      };
    }

    case 'GET_RESTAURANT_ORDER_SUMMARY_PREVIOUS_SUCCESS': {
      return {
        ...state,
        summaryPreviousLoading: false,
        summaryPrevious: format.summary(action.payload),
      };
    }

    case 'GET_ORDER_DETAILS_REQUEST': {
      return {
        ...state,
        detailLoading: true,
        detailError: undefined,
      };
    }

    case 'GET_ORDER_DETAILS_SUCCESS': {
      const order = format.order(action.payload);

      return {
        ...state,
        detailLoading: false,
        detailError: undefined,
        ordersById: {
          ...state.ordersById,
          [order.id]: {
            ...order,
          },
        },
      };
    }

    case 'GET_ORDER_DETAILS_FAILURE': {
      return {
        ...state,
        detailLoading: false,
        detailError: {
          status: action.status,
          message: action.payload.error,
        },
      };
    }

    default:
      return state;
  }
};
